<template>
  <vx-card no-shadow>

    <h2 class="mb-6">Opening Hours</h2>

    <div v-if="utcOpeningHours" class="vx-row mb-6">
      <div class="vx-col w-full opening-hours-row">
        <span class="day">Monday</span>
        <vs-switch v-model="utcOpeningHours.isOpenMonday" class="ml-6">
          <span slot="on">Open</span>
          <span slot="off">Closed</span>
        </vs-switch>

        <flat-pickr v-if="utcOpeningHours.isOpenMonday" @on-change="onMondayOpenChangeEvent" :config="configdateTimePicker" v-model="openingHours.mondayOpen" class="ml-6" placeholder="Open from..." />
        <flat-pickr v-if="utcOpeningHours.isOpenMonday" @on-change="onMondayCloseChangeEvent" :config="configdateTimePicker" v-model="openingHours.mondayClose" class="ml-3" placeholder="Closed from..." />
      </div>

      <div class="vx-col w-full opening-hours-row mt-3">
        <span class="day">Tuesday</span>
        <vs-switch v-model="utcOpeningHours.isOpenTuesday" class="ml-6">
          <span slot="on">Open</span>
          <span slot="off">Closed</span>
        </vs-switch>

        <flat-pickr v-if="utcOpeningHours.isOpenTuesday" @on-change="onTuesdayOpenChangeEvent" :config="configdateTimePicker" v-model="openingHours.tuesdayOpen" class="ml-6" placeholder="Open from..." />
        <flat-pickr v-if="utcOpeningHours.isOpenTuesday" @on-change="onTuesdayCloseChangeEvent" :config="configdateTimePicker" v-model="openingHours.tuesdayClose" class="ml-3" placeholder="Closed from..." />
      </div>

      <div class="vx-col w-full opening-hours-row mt-3">
        <span class="day">Wednesday</span>
        <vs-switch v-model="utcOpeningHours.isOpenWednesday" class="ml-6">
          <span slot="on">Open</span>
          <span slot="off">Closed</span>
        </vs-switch>

        <flat-pickr v-if="utcOpeningHours.isOpenWednesday" @on-change="onWednesdayOpenChangeEvent" :config="configdateTimePicker" v-model="openingHours.wednesdayOpen" class="ml-6" placeholder="Open from..." />
        <flat-pickr v-if="utcOpeningHours.isOpenWednesday" @on-change="onWednesdayCloseChangeEvent" :config="configdateTimePicker" v-model="openingHours.wednesdayClose" class="ml-3" placeholder="Closed from..." />
      </div>

      <div class="vx-col w-full opening-hours-row mt-3">
        <span class="day">Thursday</span>
        <vs-switch v-model="utcOpeningHours.isOpenThursday" class="ml-6">
          <span slot="on">Open</span>
          <span slot="off">Closed</span>
        </vs-switch>

        <flat-pickr v-if="utcOpeningHours.isOpenThursday" @on-change="onThursdayOpenChangeEvent" :config="configdateTimePicker" v-model="openingHours.thursdayOpen" class="ml-6" placeholder="Open from..." />
        <flat-pickr v-if="utcOpeningHours.isOpenThursday" @on-change="onThursdayCloseChangeEvent" :config="configdateTimePicker" v-model="openingHours.thursdayClose" class="ml-3" placeholder="Closed from..." />
      </div>

      <div class="vx-col w-full opening-hours-row mt-3">
        <span class="day">Friday</span>
        <vs-switch v-model="utcOpeningHours.isOpenFriday" class="ml-6">
          <span slot="on">Open</span>
          <span slot="off">Closed</span>
        </vs-switch>

        <flat-pickr v-if="utcOpeningHours.isOpenFriday" @on-change="onFridayOpenChangeEvent" :config="configdateTimePicker" v-model="openingHours.fridayOpen" class="ml-6" placeholder="Open from..." />
        <flat-pickr v-if="utcOpeningHours.isOpenFriday" @on-change="onFridayCloseChangeEvent" :config="configdateTimePicker" v-model="openingHours.fridayClose" class="ml-3" placeholder="Closed from..." />
      </div>

      <div class="vx-col w-full opening-hours-row mt-3">
        <span class="day">Saturday</span>
        <vs-switch v-model="utcOpeningHours.isOpenSaturday" class="ml-6">
          <span slot="on">Open</span>
          <span slot="off">Closed</span>
        </vs-switch>

        <flat-pickr v-if="utcOpeningHours.isOpenSaturday" @on-change="onSaturdayOpenChangeEvent" :config="configdateTimePicker" v-model="openingHours.saturdayOpen" class="ml-6" placeholder="Open from..." />
        <flat-pickr v-if="utcOpeningHours.isOpenSaturday" @on-change="onSaturdayCloseChangeEvent" :config="configdateTimePicker" v-model="openingHours.saturdayClose" class="ml-3" placeholder="Closed from..." />
      </div>

      <div class="vx-col w-full opening-hours-row mt-3">
        <span class="day">Sunday</span>
        <vs-switch v-model="utcOpeningHours.isOpenSunday" class="ml-6">
          <span slot="on">Open</span>
          <span slot="off">Closed</span>
        </vs-switch>

        <flat-pickr v-if="utcOpeningHours.isOpenSunday" @on-change="onSundayOpenChangeEvent" :config="configdateTimePicker" v-model="openingHours.sundayOpen" class="ml-6" placeholder="Open from..." />
        <flat-pickr v-if="utcOpeningHours.isOpenSunday" @on-change="onSundayCloseChangeEvent" :config="configdateTimePicker" v-model="openingHours.sundayClose" class="ml-3" placeholder="Closed from..." />
      </div>
    </div>

    <div class="flex flex-wrap items-center justify-end">
      <vs-button @click="saveOpeningHours" id="save-button" class="ml-auto mt-2">Save Opening Hours</vs-button>
    </div>
  </vx-card>
</template>

<script>
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
  components: {
    flatPickr
  },
  data () {
    return {
      venueId: null,

      configdateTimePicker: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: true,
        time_24hr: true,
        //dateFormat: 'H:i',
        defaultHour: 0,
        defaultMinute: 0,
        defaultSecond: 0
      },

      openingHours: null,
      utcOpeningHours: null
    }
  },
  methods: {
    onMondayOpenChangeEvent(selectedDates) {
      if (selectedDates.length == 1) { this.utcOpeningHours.mondayOpen = selectedDates[0].toISOString(); }
    },
    onMondayCloseChangeEvent(selectedDates) {
      if (selectedDates.length == 1) { this.utcOpeningHours.mondayClose = selectedDates[0].toISOString(); }
    },
    onTuesdayOpenChangeEvent(selectedDates) {
      if (selectedDates.length == 1) { this.utcOpeningHours.tuesdayOpen = selectedDates[0].toISOString(); }
    },
    onTuesdayCloseChangeEvent(selectedDates) {
      if (selectedDates.length == 1) { this.utcOpeningHours.tuesdayClose = selectedDates[0].toISOString(); }
    },
    onWednesdayOpenChangeEvent(selectedDates) {
      if (selectedDates.length == 1) { this.utcOpeningHours.wednesdayOpen = selectedDates[0].toISOString(); }
    },
    onWednesdayCloseChangeEvent(selectedDates) {
      if (selectedDates.length == 1) { this.utcOpeningHours.wednesdayClose = selectedDates[0].toISOString(); }
    },
    onThursdayOpenChangeEvent(selectedDates) {
      if (selectedDates.length == 1) { this.utcOpeningHours.thursdayOpen = selectedDates[0].toISOString(); }
    },
    onThursdayCloseChangeEvent(selectedDates) {
      if (selectedDates.length == 1) { this.utcOpeningHours.thursdayClose = selectedDates[0].toISOString(); }
    },
    onFridayOpenChangeEvent(selectedDates) {
      if (selectedDates.length == 1) { this.utcOpeningHours.fridayOpen = selectedDates[0].toISOString(); }
    },
    onFridayCloseChangeEvent(selectedDates) {
      if (selectedDates.length == 1) { this.utcOpeningHours.fridayClose = selectedDates[0].toISOString(); }
    },
    onSaturdayOpenChangeEvent(selectedDates) {
      if (selectedDates.length == 1) { this.utcOpeningHours.saturdayOpen = selectedDates[0].toISOString(); }
    },
    onSaturdayCloseChangeEvent(selectedDates) {
      if (selectedDates.length == 1) { this.utcOpeningHours.saturdayClose = selectedDates[0].toISOString(); }
    },
    onSundayOpenChangeEvent(selectedDates) {
      if (selectedDates.length == 1) { this.utcOpeningHours.sundayOpen = selectedDates[0].toISOString(); }
    },
    onSundayCloseChangeEvent(selectedDates) {
      if (selectedDates.length == 1) { this.utcOpeningHours.sundayClose = selectedDates[0].toISOString(); }
    },

    getMidnight: function () {
      let date = new Date();
      date.setHours(0);
      date.setMinutes(0);
      date.setSeconds(0);

      return date;
    },

    getOpeningHours: function () {
      this.$vs.loading()

      this.$http.get(process.env.VUE_APP_API +'/venue/' + this.venueId + '/info/openinghours')
          .then(resp => {
            this.openingHours = resp.data;

            if (this.openingHours.mondayOpen.startsWith("0001")) {
              this.openingHours.mondayOpen = this.getMidnight();
            }
            if (this.openingHours.mondayClose.startsWith("0001")) {
              this.openingHours.mondayClose = this.getMidnight();
            }

            if (this.openingHours.tuesdayOpen.startsWith("0001")) {
              this.openingHours.tuesdayOpen = this.getMidnight();
            }
            if (this.openingHours.tuesdayClose.startsWith("0001")) {
              this.openingHours.tuesdayClose = this.getMidnight();
            }

            if (this.openingHours.wednesdayOpen.startsWith("0001")) {
              this.openingHours.wednesdayOpen = this.getMidnight();
            }
            if (this.openingHours.wednesdayClose.startsWith("0001")) {
              this.openingHours.wednesdayClose = this.getMidnight();
            }

            if (this.openingHours.thursdayOpen.startsWith("0001")) {
              this.openingHours.thursdayOpen = this.getMidnight();
            }
            if (this.openingHours.thursdayClose.startsWith("0001")) {
              this.openingHours.thursdayClose = this.getMidnight();
            }

            if (this.openingHours.fridayOpen.startsWith("0001")) {
              this.openingHours.fridayOpen = this.getMidnight();
            }
            if (this.openingHours.fridayClose.startsWith("0001")) {
              this.openingHours.fridayClose = this.getMidnight();
            }

            if (this.openingHours.saturdayOpen.startsWith("0001")) {
              this.openingHours.saturdayOpen = this.getMidnight();
            }
            if (this.openingHours.saturdayClose.startsWith("0001")) {
              this.openingHours.saturdayClose = this.getMidnight();
            }

            if (this.openingHours.sundayOpen.startsWith("0001")) {
              this.openingHours.sundayOpen = this.getMidnight();
            }
            if (this.openingHours.sundayClose.startsWith("0001")) {
              this.openingHours.sundayClose = this.getMidnight();
            }

            this.utcOpeningHours = Object.assign({}, this.openingHours);
          })
          .catch(err => {
            console.log(err)
          })
          .finally(() => {
            this.$vs.loading.close()
          })
    },

    saveOpeningHours: function () {
      this.$vs.loading({
        background:'primary',
        color:'#fff',
        container: "#save-button",
        scale: 0.45
      })

      this.$http.post(process.env.VUE_APP_API +'/venue/' + this.venueId + '/info/openinghours', this.utcOpeningHours)
          .then((/*resp*/) => {
            this.$vs.notify({
              color:'success',
              title:'Success',
              text:'Opening hours updated'
            })
          })
          .catch(err => {
            console.log(err)

            this.$vs.notify({
              color:'danger',
              title:'Error',
              text:'Could not update opening hours'
            });
          })
          .finally(() => {
            this.$vs.loading.close("#save-button > .con-vs-loading")
          })
    }
  },
  mounted() {
    this.venueId = this.$route.params.venueId;
    this.getOpeningHours();
  }
}
</script>

<style lang="scss">
.day {
  font-weight: 500;
  width: 100px;
}

.opening-hours-row {
  display: flex;
  align-items: center;
  min-height: 40px;
}
</style>